import store from '@/store'
import { RoleR } from './signalr/role';
import { UserActiveR } from './signalr/user-active';
import { NotifyR } from './signalr/notify';
import { GStatusR } from './signalr/gstatus';
import SystemConstantParametersApi from '@/api/system-constant-parameters';

export default {
    get Development(){
        return store.state.system.development
    },
    get GStatus(){
        return store.state.system.gStatus
    },
    set GStatus(value){
        store.commit('system/setGStatus', value)
    },
    BaseURL:{
        get URL() {
            return store.state.system.url;
        },
        set URL(value) {
            store.commit('system/setUrl', value);
        },
        Define(){
            if(process.env.NODE_ENV === 'development'){
                this.URL = 'https://localhost:7287'
                store.commit('system/setDevelopment', true)
            }else{
                this.URL = 'https://tms.sertellojistik.com/api'
                store.commit('system/setDevelopment', false)
            }
        }
    },
    SignalR:{
        get role() { return new RoleR() },
        get userActive() { return new UserActiveR() },
        get notify() { return new NotifyR() },
        get gStatus(){ return new GStatusR() },
        GetInstances(){
            return {
                role: this.role,
                userActive: this.userActive,
                notify: this.notify,
                gStatus:this.gStatus
            }
        },
    }
}